import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import NumberButtons, {
  OPTIONS as NUMBER_BUTTONS_OPTIONS,
} from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberButtons';
import { useBuilderContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import { createNewItem } from 'hb-builder/utils/createNewItem';
import { BUTTON_VARIANT_OPTIONS } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';
import type { ButtonsItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonsItemAttributes';

import ButtonContent from './ButtonContent';

const ContentSettings = ({
  item,
  onChange,
}: Omit<ComponentSettingsTab<ButtonsItemAttributes>, 'defaultAttributes'>) => {
  const { addItem, getPath, removeItem } = useBuilderContext();
  const [number, setNumber] = useState(
    item.children?.length || NUMBER_BUTTONS_OPTIONS.ONE,
  );

  const handleChangeNumberButtons = (value) => {
    setNumber(value);

    if (item.children && item.children.length < value) {
      addItem({
        direction: item.children.length + 1,
        id: item.id,
        item: createNewItem(
          {
            ...item.children[0],
            attributes: {
              ...item.children[0].attributes,
              variant: BUTTON_VARIANT_OPTIONS.SECONDARY,
            },
          },
          { isDuplicate: true },
        ),
        path: getPath(item.id),
      });
    }

    if (item.children && item.children.length > value) {
      removeItem(item.children[1]?.id);
    }
  };

  return (
    <Box flexDirection="column" mt={2}>
      <NumberButtons
        item={item}
        defaultValue={number}
        onChange={handleChangeNumberButtons}
      />
      <Divider mb={5} mt={2} />
      {(item.children || []).map((button, index) => (
        <ButtonContent
          key={button.id}
          item={button}
          index={index}
          number={number}
          onChange={onChange}
        />
      ))}
    </Box>
  );
};

export default ContentSettings;
